import { Outlet, Route } from 'react-router-dom'

import { PacksPage } from './PacksPage'

export const PacksRoutes = [
    <Route key='packs' element={<Outlet />}>
        <Route index element={<PacksPage />} />
    </Route>,
]
